import { VirtualMeshDimensionConfig } from "../mms-utils/mms-virtual-mesh-config"

export const MS_VIRTUAL_MESH_CONFIG: VirtualMeshDimensionConfig = {
  shelf: {
    w43: {
      h43 : { dimensions: { x: 1.25, y: 1.2, z: 0.5 }, offset: { x: 0.59, y: -0.2, z: -0.15 } },
      h70 : { dimensions: { x: 1.25, y: 1.9, z: 0.55 }, offset: { x: 0.59, y: 0.15, z: -0.15 } },
    },
    w70: {
      h43 : { dimensions: { x: 1.93, y: 1.2, z: 0.55 }, offset: { x: 0.94, y: -0.2, z: -0.15 } },
      h70 : { dimensions: { x: 1.93, y: 1.9, z: 0.55 }, offset: { x: 0.94, y: 0.15, z: -0.15 } },
    },
  },
  corner: {
    h43 : { dimensions: { x: 1, y: 1.2, z: 1 }, offsetX: 0.4, offsetY: 0.6, offsetZ: -0.6 },
    h70 : { dimensions: { x: 1, y: 1.9, z: 1 }, offsetX: 0.4, offsetY: 0.9, offsetZ: -0.6 },
  },
}
